module.exports = __webpack_public_path__ + "static/ATELIER-MONEI-checkout-transparent-fa68a8e90182264c83ef9b2843a4d1d3.png";